
//TODO UPDATE THIS EVERY TIME WE PUSH CHANGES OUT
//Deploy Commands:
// (change line below to use PROD)
// firebase use prod
// npm run build
// firebase deploy
//Then revert to DEV config and firebase use dev

//Demo password for all user accounts: demoV$3289

//helpful command for copying backups:
//to local: gsutil cp -r gs://velocity-demo-backups/restore .
//to gs from local gsutil cp -r demo-restore/db gs://velocity-demo-backups/restore

//account import/export
//firebase auto:export demoaccounts.json
//firebase auth:import demo-restore/accounts/demoaccounts.json {HASH PARAMS HERE - SEE https://firebase.google.com/docs/cli/auth}
//should look something like firebase auth:import demo-restore/accounts/demoaccounts.json --hash-algo=SCRYPT --hash-key={KEY} --salt-separator={SEP} --rounds=8 --mem-cost=14

//velocity-demo-backups
//velocity-demo2-backups
//velocity-demo3-backups

//gcloud beta firestore import gs://velocity-demo-backups/restore
//gcloud beta firestore import gs://velocity-demo2-backups/restore
//gcloud beta firestore import gs://velocity-demo3-backups/restore

const APP_VERSION_NUMBER = '0.1.5';
//const APP_ENV = 'DEV';
//const APP_ENV = 'PROD';
const APP_ENV = 'DEMO';
//const APP_ENV = 'DEMO2';
//const APP_ENV = 'DEMO3';

const APP_CONFIG = {
  DEV: {
    ENV: 'development',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'http://localhost:3000',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyChqcfZefaCOdRG7t_2qi27YKNdm_AVBlE",
      authDomain: "velocity-app-development.firebaseapp.com",
      databaseURL: "https://velocity-app-development.firebaseio.com",
      projectId: "velocity-app-development",
      storageBucket: "velocity-app-development.appspot.com",
      messagingSenderId: "239057015867"
    },
    SENTRY_CONFIG: {
      DSN: 'https://ffa7ff81a6a542be980e190db24980b3@sentry.io/1289192'
    }
  },
  PROD: {
    ENV: 'production',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'https://app.velocitytalent.com',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyDdD1fnECDvnbEHzgCa07HlggO1HsUmdVU",
      authDomain: "velocity-app-prod-v0.firebaseapp.com",
      databaseURL: "https://velocity-app-prod-v0.firebaseio.com",
      projectId: "velocity-app-prod-v0",
      storageBucket: "velocity-app-prod-v0.appspot.com",
      messagingSenderId: "658884153268"
    },
    SENTRY_CONFIG: {
      DSN: 'https://d285140634754114abffa274c8f8023b@sentry.io/1289187'
    }
  },
  DEMO: {
    ENV: 'demo',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'http://demo.velocitytalent.com',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyB421iyUbONy4EQXgvYbJ3hYywhtl6NzZo",
      authDomain: "velocity-app-demo.firebaseapp.com",
      databaseURL: "https://velocity-app-demo.firebaseio.com",
      projectId: "velocity-app-demo",
      storageBucket: "velocity-app-demo.appspot.com",
      messagingSenderId: "847000432096"
    },
    SENTRY_CONFIG: {
      DSN: 'https://cfdd9af77f394355801b5b78bcef2f1f@sentry.io/1331019'
    }
  },
  DEMO2: {
    ENV: 'demo',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'http://demo2.velocitytalent.com',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyB3NMUqXmlTv3gF86QBEgBpU7W7CugQYXQ",
      authDomain: "velocity-app-demo2.firebaseapp.com",
      databaseURL: "https://velocity-app-demo2.firebaseio.com",
      projectId: "velocity-app-demo2",
      storageBucket: "velocity-app-demo2.appspot.com",
      messagingSenderId: "556696522102"
    },
    SENTRY_CONFIG: {
      DSN: 'https://cfdd9af77f394355801b5b78bcef2f1f@sentry.io/1331019'
    }
  },
  DEMO3: {
    ENV: 'demo',
    VERSION: APP_VERSION_NUMBER,
    ADVANCED_DEBUG: false,
    APP_URL: 'http://demo3.velocitytalent.com',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyC-28Eyx0dkLo9xgmAqUBtSo2YMDH1KInk",
      authDomain: "velocity-app-demo3.firebaseapp.com",
      databaseURL: "https://velocity-app-demo3.firebaseio.com",
      projectId: "velocity-app-demo3",
      storageBucket: "velocity-app-demo3.appspot.com",
      messagingSenderId: "124029572973"
    },
    SENTRY_CONFIG: {
      DSN: 'https://cfdd9af77f394355801b5b78bcef2f1f@sentry.io/1331019'
    }
  },
}

export default APP_CONFIG[APP_ENV];



// WEBPACK FOOTER //
// ./src/config.js